import React from "react";
import "./printable.css";

/**
 * PrintableInquiry:
 * - Renders either a profile-only page (profile prop) or a page with up to 3 items (items prop).
 * - Includes Newbell logo (public/logo.png) and company name in header.
 */
export default function PrintableInquiry({ type, profile, items = [], pageIndex = 1, totalPages = 1 }) {
  const companyName = "Newbell International Exports";

  if (type === "profile") {
    return (
      <div className="pdf-page">
        <div className="pdf-header">
          <div className="pdf-logo-block">
            <img src="/logo.png" alt="Newbell Logo" className="pdf-logo" />
            <div className="pdf-company-name">{companyName}</div>
          </div>

          <div className="pdf-title-block">
            <h1 className="pdf-title">Inquiry Summary</h1>
            <div className="pdf-sub">Generated on: {new Date().toLocaleDateString()}</div>
          </div>
        </div>

        <div className="pdf-section">
          <h2 className="pdf-section-title">Buyer / Contact Details</h2>
          <div className="pdf-profile-grid">
            <div><strong>Full name</strong><div className="pdf-value">{profile?.fullName || "-"}</div></div>
            <div><strong>Company</strong><div className="pdf-value">{profile?.companyName || "-"}</div></div>
            <div><strong>Email</strong><div className="pdf-value">{profile?.email || "-"}</div></div>
            <div><strong>Phone</strong><div className="pdf-value">{profile?.phone || "-"}</div></div>
            <div><strong>Business type</strong><div className="pdf-value">{profile?.businessType || "-"}</div></div>
            <div><strong>Primary sourcing</strong><div className="pdf-value">{(profile?.countries || []).join(", ") || "-"}</div></div>
            <div style={{ gridColumn: "1 / -1" }}>
              <strong>Remarks</strong>
              <div className="pdf-value">{profile?.remarks || "-"}</div>
            </div>
          </div>
        </div>

        <div className="pdf-footer">
          <div className="pdf-footer-left">{companyName}</div>
          <div className="pdf-footer-right">Page {pageIndex} / {totalPages}</div>
        </div>
      </div>
    );
  }

  // items page
  return (
    <div className="pdf-page">
      <div className="pdf-header">
        <div className="pdf-logo-block">
          <img src="/logo.png" alt="Newbell Logo" className="pdf-logo small" />
          <div className="pdf-company-name small">{companyName}</div>
        </div>

        <div className="pdf-title-block">
          <h2 className="pdf-title-small">Inquiry Items</h2>
          <div className="pdf-sub">Items on this page: {items.length}</div>
        </div>
      </div>

      <div className="pdf-section pdf-items-section">
        {items.map((it, idx) => (
          <div className="pdf-item" key={idx}>
            <div className="pdf-item-index">Item {it._globalIndex ?? idx + 1}</div>
            <h3 className="pdf-item-title">{it.productName}</h3>
            <div className="pdf-item-meta">{it.country ?? "-"} • {it.category ?? "-"}</div>

            {Array.isArray(it.selectedTags) && it.selectedTags.length > 0 && (
              <div className="pdf-item-tags">
                {it.selectedTags.map((t, i) => (
                  <span className="pdf-tag" key={i}>{t}</span>
                ))}
              </div>
            )}

            <div className="pdf-item-desc">
              <strong>Requirements:</strong>
              <div className="pdf-value">{it.additionalText || it.requirements || "-"}</div>
            </div>

            {it.description && (
              <div className="pdf-item-desc">
                <strong>Description:</strong>
                <div className="pdf-value">{it.description}</div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="pdf-footer">
        <div className="pdf-footer-left">{companyName}</div>
        <div className="pdf-footer-right">Page {pageIndex} / {totalPages}</div>
      </div>
    </div>
  );
}